import React from "react";
import {Title3} from "../../layouts/components/Titles";

const NutritionalInfoPDP = (props) => {
  const {nutritionalInfo} = props;

  return <div className="nutritional-info">
    <NutritionalPills nutritionalInfo={nutritionalInfo}/>
  </div>;
};

export default NutritionalInfoPDP;

const NutritionalPills = (props) => {
  const {nutritionalInfo} = props;
  return <div className='nutritional-pills flex flex-wrap gap-5'>{
    nutritionalInfo
      .value
      .map(item => <NutritionalPill key={item?.label} item={item}/>)
  }</div>;
};

const NutritionalPill = (props) => {
  const {item} = props;

  return <div
    className={`
    nutritional-pill
    flex
    flex-direction-column
    align-items-center
    border-default
    border-radius-lg
    padding-10
    text-align-center
    word-break
    `
    }
    style={{
      width: "96px",
      borderColor: "rgba(153,153,153, 0.6)"
    }}
  >
    <div className="margin-0">{item?.label}</div>
    <Title3
      className="text-color-green text-strong"
      style={{
        justifySelf: "flex-start",
        fontSize: "20px"
      }}
    >
      {item?.primaryValue}
    </Title3>

    <div className="small text-color-dimmed">
      {item?.secondaryValue}
    </div>
  </div>;
};
